import React, { useEffect, useState } from "react";
import crossblack from "../../assets/images/resource/crossblack.svg";
import NextBtn from "./nextbutton";
import { Form } from "react-bootstrap";
import { withoutAuthInstance } from "../../config/axios";
import { Modal } from "react-bootstrap";

const StepSecond = ({ handleStepChange, setSkill, skill ,value, setValue}) => {
  const [addInputBar, setAddInputBar] = useState(false);
  const [listOfSkillArr, setListOfSkillArr] = useState([])

  const handleSkillArr = (value) => {
    if (skill.includes(value)) {
      const arr = skill.filter((ele) => ele !== value)
      setSkill(arr)
      return
    }
    const newArr = [...skill, value];
    setSkill(newArr)
  }
  const handleAddSkill = () => {
    setAddInputBar(true)
  }

  const handleAddNewSkill = async (value, setName) => {
    const payload = { skill: value }
    const res = await withoutAuthInstance.post('/skill/add-skill', payload)
    if (res.status === 201) {
      setListOfSkillArr([...listOfSkillArr, res.data])
      setAddInputBar(false)
      setName("")
    }
  }

  const getAllSkillList = async () => {
    const res = await withoutAuthInstance.get('/skill/get-skill-list')
    console.log({ res });
    if (res.data) {
      setListOfSkillArr(res.data)

    }
  }
  useEffect(() => {
    getAllSkillList()
  }, [])
  const handleChange = (key) => {
    setValue({...value,...key})
  }
console.log('new Value---->>',value);
  return (

    <>
      <Form onSubmit={() => handleStepChange(1, 25)}>
        <div className='resource-step-content'>
          <div className='resource-content'>
            <div className='resource-step-heading'>
              <h4>Contact Details</h4>
              <p>Please select which service you are interested in.</p>
            </div>
            <div className='resource-skill'>
              {listOfSkillArr && listOfSkillArr.length > 0 && listOfSkillArr.map((ele) => {
                return (
                  <span onClick={() => handleSkillArr(ele.skill)} className={`${skill && skill?.includes(ele.skill) ? 'active' : ''}`}>{ele.skill}</span>
                )
              })}
              <div className='add-skill-btn' onClick={handleAddSkill}>
                <span>
                  <img src={crossblack} alt='plus' />
                  Add Skill
                </span>
              </div>

            </div>
            <div className='resource-step-heading'>
              <h4>Highlights</h4>
              <div className='resource-form'>
                <Form.Group className='resource-dev-input'>
                  <textarea
                    placeholder='Lorem Ipsum'
                    name='highlight'
                    // className={errors.jobDescription ? "error-field" : ""}
                    // {...register("jobDescription")}
                    value={value.highlight}
                    onChange={(e) => handleChange({ highlight: e.target.value })}
                  />
                  {/* {errors?.jobDescription ? (
                <p className='error-text'>{errors?.jobDescription?.message}</p>
              ) : (
                ""
              )} */}
                </Form.Group>
              </div>
              <Form.Group className='resource-dev-input'>
                <label>Language</label>
                <select onChange={(e)=>handleChange({language:e.target.value})}>
                  <option value='' disabled>
                    Select option
                  </option>
                  <option value="English">English</option>
                  <option value="Hindi">Hindi</option>

                </select>
              </Form.Group>

              <Form.Group className='resource-dev-input'>
                <label>Work Type </label>
                <select onChange={(e)=>handleChange({work_Type:e.target.value})}>
                  <option value='' disabled>
                    Select option
                  </option>
                  <option value="Remote to work">Remote to work</option>
                  <option value="Work from home">Work from home</option>

                </select>
              </Form.Group>
            </div>

            <NextBtn handleStepChange={handleStepChange} />
          </div>
        </div>
      </Form>
      <AddSkillModal
        show={addInputBar}
        setAddInputBar={setAddInputBar} handleAddNewSkill={handleAddNewSkill} />
    </>
  );
};
export default StepSecond;

const AddSkillModal = ({ show, setAddInputBar, handleAddNewSkill }) => {
  const [name, setName] = useState("")
  const handleChange = (value) => {
    setName(value)
  }
  return (
    <Modal show={show}
      onHide={() => setAddInputBar(false)}
      className="resource-modal add-skill-modal"
      centered
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>Add Skill</Modal.Title>
          <p>Write the name of the skill you want to add</p>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className='add-skill-form'>
          <input type='text' className="form-control" onChange={(e) => handleChange(e.target.value)} value={name} />
          <span className="cta-btn btn" onClick={() => handleAddNewSkill(name, setName)}>ADD</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};
